import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';

import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';

import ProductImagesHome from '../../../components/Dashboard/ProductImages/ProductImagesHome';
import { dashboardBreadcrumb } from '../../../data/routes';

const AdminLayout = ({
  auctionName,
  uploadStatus,
  laneName,
  AuctionID,
  LaneID,
  MediaState,
}) => {
  const {
    AuthStore: { memberName },
  } = useStores();

  // const auctionID = AuctionID;
  // const laneID = LaneID;
  let items = [];
  if (LaneID !== undefined && LaneID !== null) {
    items = [
      dashboardBreadcrumb,
      { to: '/auctions', label: 'Auctions' },
      { to: '/auction/' + AuctionID + '/lanes', label: 'Lanes' },
      {
        // to: '/auction/' + AuctionID + '/lane/' + LaneID + '/productimages',
        label: 'Product Images',
      },
    ];
  } else {
    items = [
      dashboardBreadcrumb,
      { to: '/auctions', label: 'Auctions' },

      {
        // to: '/auction/' + AuctionID + '/productimages',
        label: uploadStatus ? `Product Images (${uploadStatus})` : 'Product Images',
      },
    ];
  }


  const getAuctionAndLaneName = () => {
      // console.log('laneName', !laneName, laneName, auctionName)
    if (!laneName) return auctionName;
    return `${auctionName} - ${laneName}`;
  }
  const auctionAndLaneName = getAuctionAndLaneName();

  return (
    <Layout>
      <TopBarContainer
        auctionAndLaneName={auctionAndLaneName}
        // title={`Product Images`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={{ pathname: to, state: { auctionName } }}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        {/* <PageNavRightContainer>
                    <SelectAuctionContainer title='Views' noneselectedText='---Select Auction---' />
                </PageNavRightContainer> */}
      </PageNavContainer>
      <MainContainer>
        <ProductImagesHome
          uploadStatus={uploadStatus}
          auctionName={auctionName}
          AuctionID={AuctionID}
          LaneID={LaneID}
          MediaState={MediaState}
        ></ProductImagesHome>
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
